import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import NewsFeed from "./components/NewsFeed";
import Timeline from "./components/Timeline";
import Reversal from "./components/Reversal";
import Responses from "./components/Responses";
import Topics from "./components/Topics";
import Subscribe from "./components/Subscribe";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqList } from "@/mocks/guaMore";

const TITLE = "全网热瓜｜热门事件后续与最新进展追踪";
const DESCRIPTION =
  "全网热瓜专注于全网热门事件后续与最新进展追踪，持续汇总每起事件的时间线、反转节点与当事人最新回应。按话题跟踪更新进度，从发酵到出结果，不再漏掉关键进展。";
const KEYWORDS =
  "全网热瓜,全网热瓜后续,全网热瓜最新进展,全网热瓜反转,全网热瓜当事人回应,全网热瓜最新动态,吃瓜,热门事件追踪";

function applyMeta() {
  const setMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
    let el = document.head.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };
  const setCanonical = (href: string) => {
    let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
  };

  document.title = TITLE;
  setMeta("description", DESCRIPTION);
  setMeta("keywords", KEYWORDS);
  setMeta("robots", "index, follow");
  setMeta("Last-Modified", new Date().toISOString());
  setMeta("author", "全网热瓜");
  setMeta("og:title", TITLE, "property");
  setMeta("og:description", DESCRIPTION, "property");
  setMeta("og:type", "website", "property");
  setMeta("og:site_name", "全网热瓜", "property");
  setMeta("og:locale", "zh_CN", "property");
  setMeta("twitter:card", "summary_large_image", "property");
  setMeta("twitter:title", TITLE, "property");
  setMeta("twitter:description", DESCRIPTION, "property");
  const canonical = window.location.origin + window.location.pathname;
  setCanonical(canonical);
  setMeta("og:url", canonical, "property");
}

function injectJsonLd() {
  document.getElementById("gua-jsonld")?.remove();
  const base = window.location.origin + window.location.pathname;
  const webSite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "全网热瓜",
    url: base,
    description: DESCRIPTION,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: { "@type": "EntryPoint", urlTemplate: `${base}?q={search_term_string}` },
      "query-input": "required name=search_term_string",
    },
  };
  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.slice(0, 3).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "全网热瓜",
    url: base,
    logo: `${base}logo.png`,
  };
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "gua-jsonld";
  script.text = JSON.stringify([webSite, org, faq]);
  document.head.appendChild(script);
}

export default function Home() {
  useEffect(() => {
    applyMeta();
    injectJsonLd();
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <NewsFeed />
        <Timeline />
        <Reversal />
        <Responses />
        <Topics />
        <Subscribe />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}